export const socialSelector = {
  socialSelectorViewStories: "View stories",
  socialSelectorGoToProfile: "Go to profile",
  socialSelectorGoToCommunity: "Go to community",
  socialSelectorCancel: "Cancel",
  socialSelectorOptionsFor: "Options for {{name}}",
  socialSelectorLabelAyg: "Official platform",
  socialSelectorLabelProvider: "Game provider",
  socialSelectorLabelUser: "Player",
  socialSelectorLabelCommunity: "Randrush Community",
  socialSelectorPlayInFeed: "Play in feed",
};
